import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, X } from 'lucide-react';

export default function StickyNote() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Check if sticky note was previously closed
    const wasNoteClosed = localStorage.getItem('sticky_note_closed');
    if (wasNoteClosed === 'true') {
      setIsVisible(false);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('sticky_note_closed', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="sticky top-0 z-50 bg-gradient-to-r from-[#143D60] to-[#A0C878] p-3 text-sm shadow-md">
      <div className="container mx-auto flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <AlertCircle className="h-5 w-5 text-[#DDEB9D]" />
          <p className="text-[#DDEB9D] nature-text">
            We are working on adding more features and services. Please share your thoughts through our{' '}
            <Link to="/contact" className="underline font-medium hover:text-white">
              contact page
            </Link>
          </p>
        </div>
        <button
          onClick={handleClose}
          className="text-[#DDEB9D] hover:text-white transition-colors"
          aria-label="Close notification"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}